// 导出流文件
export function streamFile(res, title="数据指标") {
    let blob = new Blob([res], {type: 'application/vnd.ms-excel;'});
    let downloadElement = document.createElement("a");
    let href = window.URL.createObjectURL(blob); //创建下载的链接
    downloadElement.href = href;
    // downloadElement.download = fileName; //下载后文件名x
    downloadElement.download = `${title}.xls`; //下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); //点击下载
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
}